<template>
  <b-modal
    size="lg"
    hide-footer
    id="modal-component"
    :title="
      editComponent ? 'Edit système : ' + editComponent.name : 'Nouveau système'
    "
  >
    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-2">
        <b-col sm="6">
          <b-card bg-variant="light">
            <b-form-group
              label="Dénomination système:"
              label-for="nested-diagnostic"

            >
              <b-form-input
                v-model="form.name"
                id="nested-diagnostic"
              ></b-form-input>
            </b-form-group>
          </b-card>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Type"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              v-model="form.typeId"
              :options="types"
              :select-size="types.length"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>

      </b-row>
     <!--  <b-row class="mb-1">
          <b-col sm="6" class="mb-2">
          <b-form-group
            label="Immeuble"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              v-model="form.building"
              :options="buildings"
              required
            ></b-form-select>
          </b-form-group>
        </b-col> -->

        <!-- <b-col sm="6">
          <b-form-group
            label="Usages"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              v-model="form.usages"
              multiple
              :options="usages"
              :select-size="usages.length"
              required
            ></b-form-select>
          </b-form-group>

        </b-col>
        
      </b-row> -->
      <!-- <b-row class="mt-2 pb-3 border-bottom">
        <span class="mr-1" v-for="usage in form.usages" :key="usage.id"
          >{{ usage.name }} ;
        </span>
      </b-row> -->
      <!-- <b-row>
        <b-col sm="10">
          <h5>Critères & Spécificités</h5>
          <div
            v-for="(partSpecs, index) in form.partsAndSpecificities"
            :key="index"
            class="border-bottom mt-2"
          >
   
            <b-form-group
              :label="'Critère ' + (index + 1)"
              label-for="nested-autoRef"
              label-cols-sm="2"
              label-align-sm="right"
            >
              <b-form-input v-model="partSpecs.part.name"></b-form-input>
              <b-input-group>
                <b-form-group label-cols-sm="3">
                  <b-form-checkbox
                    :id="partSpecs.part.name"
                    v-model="partSpecs.part.properties.compulsory"
                    :name="partSpecs.part.name"
                    value="true"
                    unchecked-value="false"
                  >
                    Obligatoire
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols-sm="3">
                  <b-form-radio
                    v-model="partSpecs.part.properties.isMultiple"
                    :name="partSpecs.part.name"
                    value="true"
                    >Réponse multiple</b-form-radio
                  >
                  <b-form-radio
                    v-model="partSpecs.part.properties.isMultiple"
                    :name="partSpecs.part.name"
                    value="false"
                    >Réponse unique</b-form-radio
                  >
                </b-form-group>
              </b-input-group>
              <b-input-group>
                <b-form-textarea
                  v-model="partSpecs.part.properties.help"
                  placeholder="Aide"
                  rows="2"
                  max-rows="6"
                ></b-form-textarea>
              </b-input-group>
            </b-form-group>


            <div class="ml-5">
              <b-form-group
                v-for="(specificity, index) in partSpecs.specificities"
                :key="index"
                :label="'spécificité ' + (index + 1)"
                label-for="nested-autoRef"
                label-cols-sm="5"
                label-align-sm="right"
              >
                <b-input-group>
                  <b-form-input v-model="specificity.name"></b-form-input><br />

                  <b-input-group-append>
                    <b-button
                      v-if="
                        specificity ===
                        partSpecs.specificities[
                          partSpecs.specificities.length - 1
                        ]
                      "
                      @click="addSpecificity(specificity, partSpecs)"
                      variant="primary"
                    >
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>


            <b-button
              v-if="
                partSpecs ===
                form.partsAndSpecificities[
                  form.partsAndSpecificities.length - 1
                ]
              "
              @click="addPart"
              block
              class="mt-3 mb-3"
              variant="primary"
            >
              <b-icon icon="plus" font-scale="2"></b-icon>
            </b-button>

          </div>
        </b-col>
      </b-row> -->

      <b-alert :variant="variant" :show="success">{{ message }}</b-alert>
      <b-button block class="mt-3 mb-3" type="submit" variant="primary"
        >{{ editComponent ? "Modifier" : "Ajouter" }}
        <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
require("json-circular-stringify");

export default {
  name: "ModalComposant",
  props: {
    editComponent: Object,
    duplicComponent: Object,

  },
  data() {
    return {
      form: {
        // building: {},
        usages: [],
        type: {},
        technology: {},
        partsAndSpecificities: [
          {
            part: {
              name: "",
              properties: { compulsory: false, isMultiple: true, help: "" },
            },
            specificities: [{ name: "" }],
          },
        ],
        specificities: [{ name: "", part: {} }],
        name: "",
      },
      usages: [],
      types: [],
      technologies: [],
      success: false,
      isLoading: false,
      message: "",
      variant: "",
    };
  },
  components: {},
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          this.usages = json.usage.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
          this.types = json.types.map((item) => {
            item.value = item.id;
            item.text = item.name;
            return { ...item };
          });
          // this.technologies = json.technology.map((item) => {
          //   item.value = item;
          //   item.text = item.name;
          //   return { ...item };
          // });

          // this.form.technology = this.technologies[0];

          // console.log(this.editComponent);

          // IF EDIT
          if (this.editComponent || this.duplicComponent) {
           const clone = this.editComponent ? this.editComponent : this.duplicComponent
            this.form = clone;
            // console.log(this.form);

            if (
              !this.form.partsAndSpecificities ||
              this.form.partsAndSpecificities.length === 0
            ) {
              this.form.partsAndSpecificities = [
                {
                  part: {
                    name: "",
                    properties: {
                      compulsory: false,
                      isMultiple: true,
                      help: "",
                    },
                  },
                  specificities: [{ name: "" }],
                },
              ];
            }

            for (const [
              index,
              partsAndSpec,
            ] of this.form.partsAndSpecificities.entries()) {
              if (!partsAndSpec.part.properties) {
                this.form.partsAndSpecificities[index].part.properties = {
                  compulsory: false,
                  isMultiple: true,
                  help: "",
                };
              }
            }
            console.log(this.form);

            this.form.usages = this.usages.filter((item) => {
              return clone.usagesIds.includes(item.id);
            });
            this.form.type = this.types.find((item) => {
              return clone.typeId === item.id;
            });
          }
        });
    },
    onSubmit() {
      console.log(this.form);
      this.isLoading = true;
      // this.form.componentIds = this.form.components.map((item)=>item.id);
      if (this.duplicComponent) {
        delete this.form.id;
      }

      this.form.partsAndSpecificities = this.form.partsAndSpecificities.filter(
        (item) => {
          item.specificities = item.specificities.filter((spec) => !!spec.name);
          return !!item.part.name;
        }
      );

      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/" +
          (this.editComponent ? "updateComponent" : "saveComponent"),
        {
          method: "POST",
          body: JSON.stringify(this.form),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;

          if (rep.status === 200) {
            // this.form = {
            //   usages: [],
            //   technology: {},
            //   partsAndSpecificities: [
            //     { part: { name: "" }, specificities: [{ name: "" }] },
            //   ],
            //   specificities: [{ name: "", part: {} }],
            //   name: "",
            // };
            this.variant = "success";
            if (this.editComponent) {
              this.message = "Système modifié avec succès";
            } else {
              this.message = "Système ajouté avec succès";
            }
          } else {
            this.variant = "danger";

            this.message = "Erreur lors  de l'enregistrement";
          }
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
    addPart() {
      this.form.partsAndSpecificities.push({
        part: {
          name: "",
          properties: { compulsory: false, isMultiple: true, help: "" },
        },
        specificities: [{ name: "" }],
      });
    },
    addSpecificity(specificity, partSpecs) {
      let temp_part = this.form.partsAndSpecificities.find(
        (item) => item.part.name === partSpecs.part.name
      );

      temp_part.specificities.push({ name: "" });
      // console.log(this.form.partsAndSpecificities);
    },
  },
};
</script>
<style></style>
